import { Component, input, output, effect, ViewChild, ElementRef, HostListener } from '@angular/core';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.html',
})
export class NotificationDialog {
  @ViewChild('okBtn') okBtn?: ElementRef<HTMLButtonElement>;

  visible = input.required<boolean>();
  message = input.required<string>();
  type = input<'success' | 'error'>('success');
  showViewButton = input<boolean>(false);

  closed = output<void>();
  view = output<void>();

  constructor() {
    effect(() => {
      if (this.visible()) {
        setTimeout(() => this.okBtn?.nativeElement.focus(), 0);
      }
    });
  }

  @HostListener('document:keydown.tab', ['$event'])
  handleTab(event: Event): void {
    console.log('NotificationDialog initialized with message:', this.message(), 'and type:', this.type(), this.visible());
    if (!this.visible()) return;
    const okElement = this.okBtn?.nativeElement;
    if (document.activeElement === okElement) {
      (event as KeyboardEvent).preventDefault();
    } else {
      okElement?.focus();
    }
  }

  @HostListener('document:keydown.escape')
  handleEscape(): void {
    console.log('NotificationDialog initialized with message:', this.message(), 'and type:', this.type(), this.visible());
    if (this.visible()) {
      this.closed.emit();
    }
  }
}
